import load from 'load-script'
import once from 'lodash/once'
import { apiClient } from 'pobble-components/dist/api'
import { getPobbleEnv } from 'pobble-components/dist/utils'

const GoogleAppIds = {
  local:
    '31767500614-uvmid9gc0l3ntipesq9jrib1g9bs3h1g.apps.googleusercontent.com',
  stg:
    '31767500614-es4e3115v06cohso76mtt9o46jvtt9pa.apps.googleusercontent.com',
  prod:
    '31767500614-unpr3ttf9u5drgcq0ug3m42gfsll40eb.apps.googleusercontent.com'
}

const initGoogleSDK = once(() => {
  window.googleInitSDK = () => {
    const { gapi } = window
    gapi.load('auth2')
  }
  load('https://apis.google.com/js/platform.js?onload=googleInitSDK')
})

const apiGoogleLogin = (data, params) =>
  apiClient.post('/v3/google_authentication', data, { params })

const apiGoogleConnect = (data, params) =>
  apiClient.post('/v3/google_authentication/connect_oauth_identity', data, {
    params
  })

const googleLogin = () => {
  return new Promise((resolve, reject) => {
    const { gapi } = window
    gapi.auth2.authorize(
      {
        client_id: GoogleAppIds[getPobbleEnv()],
        scope: 'email profile openid',
        response_type: 'id_token permission'
      },
      res => {
        if (res.error && res.error === 'popup_closed_by_user') {
          return reject('CANCEL')
        }
        apiGoogleLogin(
          {
            code: res.id_token,
            signup_origin: localStorage.getItem('origin')
          },
          { include: 'account.finish_signup_status' }
        )
          .then(resolve)
          .catch(reject)
      }
    )
  })
}

const googleConnect = () => {
  return new Promise((resolve, reject) => {
    const { gapi } = window
    gapi.auth2.authorize(
      {
        client_id: GoogleAppIds[getPobbleEnv()],
        scope: 'email profile openid',
        response_type: 'id_token permission'
      },
      res => {
        if (res.error && res.error === 'popup_closed_by_user') {
          return reject('CANCEL')
        }
        apiGoogleConnect(
          { code: res.id_token },
          {
            include: 'account.oauth_identities,account.oauth_identity.provider'
          }
        )
          .then(resolve)
          .catch(reject)
      }
    )
  })
}

export { initGoogleSDK, googleLogin, googleConnect }
